import * as React from 'react'
import styled from 'style/styled-components'

export enum IconSource {
  igsCrmIcons = 'igsCrmIcons',
  builtInIcons = 'inherit'
}

const StyledIcon = styled.span`
    font-family: ${(props: IconProps): string => props.iconSource || IconSource.igsCrmIcons}, serif;
    
    ::before {
      content: "${(props: IconProps): string => props.iconName}";
    }
`

const Icon = (props: IconProps): JSX.Element => (
  <StyledIcon {...props}/>
)

export interface IconProps extends React.HTMLAttributes<HTMLSpanElement> {
  iconName: string
  iconSource?: IconSource
}

export default Icon



// WEBPACK FOOTER //
// ./src/components/_atoms/icon.tsx